/**
 * 科学检索
 * 【动态表单】
 * 【工具方法区】
 * 【Navigate】导航
 * 【Form】表单
 * 【Page】分页
 * 【Object】
 * 【Date】日期
 * 【Number】
 * 【Array】
 * 【DOM】
 * 【File】
 */
import { httpFormdata } from 'r3cps/__utils__/request';


export default {
  /* ============================================== 【动态表单】 START ============================================== */
  getDatePickerConfig(listType) {
    const map = {
      date: { pickerType: 'date', format: 'yyyy-MM-dd', isRange: false },
      daterange: { pickerType: 'daterange', format: 'yyyy-MM-dd', isRange: true },
      datetime: { pickerType: 'datetime', format: 'yyyy-MM-dd HH:mm:ss', isRange: false },
      datetimerange: { pickerType: 'datetimerange', format: 'yyyy-MM-dd HH:mm:ss', isRange: true },
      year: { pickerType: 'year', format: 'yyyy', isRange: false },
      month: { pickerType: 'month', format: 'yyyy-MM', isRange: false },
    };
    return map[listType] || null;
  },
  resolveDatePickerConfig(tabth = {}, listType) {
    const configuredType = listType || tabth.datePickerType || tabth.listType || tabth.pickerType;
    if (this.getDatePickerConfig(configuredType)) {
      return {
        ...this.getDatePickerConfig(configuredType),
        listType: configuredType,
      };
    }
    return null;
  },
  dynamicForm(item) {
    switch (item.type) {
      case 'date': {
        const dateCfg = this.resolveDatePickerConfig(item.tabth);
        const pickerType = (item.tabth && item.tabth.pickerType)
          || (dateCfg && dateCfg.pickerType)
          || 'datetimerange';
        const format = (item.tabth && (item.tabth.dateFormat || item.tabth.format))
          || (dateCfg && dateCfg.format)
          || 'yyyy-MM-dd HH:mm:ss';
        return {
          vModelFormat: true,
          style: item.tabth.isfilter ? 'date' : '', // 输入框类型
          type: pickerType,
          label: item.tabth.name, // 输入框前文字
          value: item.tabth.colname, // 输入框的值
          format,
          width: '6', // 所占的宽度 (宽度分为24份,数值代表所占份数的宽度)
          icon: 'md-alarm', // 输入框后带的图标,暂只有输入框支持
          placeholder: '', // 占位文本，默认为请输入
          transfer: true,
          ghost: false, // 是否关闭幽灵按钮，默认开启
          clearable: true,
          itemdata: {
            isnotnull: item.tabth.isnotnull
          }
        }
      }
      case 'time':
        return {
          style: item.tabth.isfilter ? 'time' : '',
          type: 'timerange',
          label: item.tabth.name,
          value: item.tabth.colname,
          format: 'HH:mm:ss',
          width: '6',
          placeholder: '',
          transfer: true,
          clearable: true,
          itemdata: {
            isnotnull: item.tabth.isnotnull
          }
        }
      case 'bosPopInput':
        const dataKey = item.tabth ? item.tabth.colname : item.colname;
        const modalCfg = item.bosPopModal || (item.tabth && item.tabth.reftable ? {
          tableName: item.tabth.reftable,
          tableId: item.tabth.reftableid,
          dataKey,
        } : null);
        return {
          style: 'bosPopInput',
          label: item.tabth.name,
          colname: dataKey,
          value: modalCfg ? `${dataKey}__DISPLAY` : (item.value || dataKey),
          width: item.width || '6',
          icon: (item.tabth.icon || item.icon) || 'ios-search',
          readonly: item.readonly !== false,
          placeholder: item.tabth.placeholder || item.placeholder || '',
          disabled: item.disabled || item.tabth.disabled || false,
          bosPopModal: modalCfg,
          popClick: item.popClick || item.tabth.popClick,
          iconclick: item.iconclick || item.tabth.iconclick,
          class: item.class || item.tabth.class,
          height: item.height || item.tabth.height,
        };
      case 'propInput':
        return {
          style: 'dropSelect', // 输入框弹框单多选
          width: '6',
          itemdata: {
            colid: item.tabth.colid,
            colname: item.tabth.colname, // 当前字段的名称
            /* col: 1,
            datelimit: 'all',
            display: 'text', // 显示什么类型，例如xml表示弹窗多选加导入功能，mrp表示下拉多选
            fkdesc: item.tabth.fkdesc, */
            fkdisplay: item.tabth.fkdisplay, // 外键关联类型
            inputname: item.tabth.inputname, // 这个是做中文类型的模糊查询字段，例如ENAME
            isfk: true, // 是否有fk键
            isnotnull: false, // 是否必填
            /* isuppercase: false, // 是否转大写
            length: 65535, // 最大长度是多少 */
            name: item.tabth.name, // input前面显示的lable值
            readonly: false, // 是否可编辑，对应input   readonly属性
            /* reftable: item.tabth.reftable,
            reftableid: item.tabth.reftableid,
            row: 1,
            scale: 0,
            statsize: -1,
            type: item.tabth.type, // 这个是后台用的 */
            pid: '',
            valuedata: '', // 这个是选择的值
            precolnameslist: item.tabth.precolnameslist ? item.tabth.precolnameslist.map(y => {
              return {
                ...y,
                refcolval: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).userenv.$USER_PHY_WAREHOUSE_ID$ : ''
              }
            }) : []
          },
        }
      case 'text':
        return {
          style: item.tabth.isfilter ? 'input' : '', // 输入框类型
          label: item.tabth.name, // 输入框前文字
          value: item.tabth.colname, // 输入框的值
          width: '6', // 所占的宽度 (宽度分为24份,数值代表所占份数的宽度)
          icon: '', // 输入框后带的图标,暂只有输入框支持
          placeholder: '', // 占位文本，默认为请输入
          clearable: true,
          ghost: false, // 是否关闭幽灵按钮，默认开启
        }
      case 'number':
        return {
          style: item.tabth.isfilter ? 'input' : '', // 输入框类型
          label: item.tabth.name, // 输入框前文字
          value: item.tabth.colname, // 输入框的值
          width: '6', // 所占的宽度 (宽度分为24份,数值代表所占份数的宽度)
          icon: '', // 输入框后带的图标,暂只有输入框支持
          placeholder: '', // 占位文本，默认为请输入
          clearable: true,
          ghost: false, // 是否关闭幽灵按钮，默认开启
        }
      case 'select':
        return {
          style: item.tabth.isfilter ? 'select' : '', // 下拉框类型
          label: item.tabth.name, // 下拉框前的值
          value: item.tabth.colname, // 输入框的值
          width: '6', // 所占宽度宽度
          clearable: true, // 是否显示下来清空按钮
          multiple: true, // 布尔值,下拉框是否开启多选,默认为不开启
          options: this.converSelect(item.tabth.combobox)
        }
      default:
        return {}
    }
  },
  // 字段选项组转换
  converSelect(val) {
    const list = [];
    val.forEach((item, index) => {
      list[index] = {
        label: item.limitdesc,
        value: item.limitval
      };
    });
    return list;
  },

  //--------------工具方法区--------------------------
  httpFormdata(data) {
    return httpFormdata(data)
  },

  /**
   *
   * @param {消息框类型} type :String,
   * @param {当前页面实例} self ,
   * @param {接口返回结果} res :Object,
   * @param {是否定制消息框title} isTitle:String
   * @param {消息框自定义render} renderFun :function
   */
  tipShow(type, self, res, isTitle, renderFun) {
    self.$Modal[type]({
      title: isTitle || $i18n.t('mT.tips'), // 提示
      content: renderFun || res.data.message,
      cancelType: true,
      titleAlign: 'left',
      closable: true,
      mask: true,
      draggable: true,
      className: 'ark-dialog',
      keyDown: (event) => {
        if ([27, 13].includes(event.keyCode)) {
          self.$Modal.remove()
        }
      },
      render: renderFun,
    })
  },

  /**
   * $Message类型的提示框：
   * @self {object} self 指向当前this
   * @type {string} (eg.'warning'/'error'/'success'……)
   * @tips {string} 当tipsType=1或不传时，tips为语言包中modalTips对应的key；当tipsType!=1时，tips为要展示的提示信息(如接口直接返回的message)
   * @tipsType {number} 默认为1，等于1则使用语言包中的modalTips，不等于1则使用传过来的tips
   */
  msgTips(self, type, tips, tipsType = 1) {
    self.$Message[type]({
      content: tipsType == 1 ? $i18n.t(`tip.${tips}`) : tips, // 请选择需要新增退单记录！
      duration: 5,
      top: 80,
    })
  },
  /**
   *
   * @param {this} self
   * @param {弹框配置的名称} modalConfig
   * @param {弹框文件名称} pageName
   * @param {弹框标题} confirmTitle
   */
  importTable(self, modalConfig, pageName, confirmTitle) {
    console.log(confirmTitle)
    self[modalConfig].confirmTitle = confirmTitle
      ? $i18n.t(`${confirmTitle}`)
      : self[modalConfig].confirmTitle // 弹框标题
    self.$children.find((item) => item.name === pageName).openConfirm() // 文件名称
  },

  /**
   * key：value，Map对象生成,并查询相应的key值
   */
  generateMap(keyArr,valueArr,serachV){
    let mapObj = new Map();
    let serachValue
    keyArr.forEach((e, i) => { mapObj.set(e, valueArr[i]) });
    mapObj.forEach((v, k) => {
      if (k === serachV) serachValue = v;
    });
    return serachValue;
  },

  /**
   * 用当前时间生成唯一Key
   * @returns key
   */
  generateKey() {
    const now = new Date()
    const year = now.getFullYear()
    let month = now.getMonth() + 1
    let day = now.getDate()
    let hour = now.getHours()
    let minutes = now.getMinutes()
    let seconds = now.getSeconds()
    String(month).length < 2 ? (month = Number('0' + month)) : month
    String(day).length < 2 ? (day = Number('0' + day)) : day
    String(hour).length < 2 ? (hour = Number('0' + hour)) : hour
    String(minutes).length < 2 ? (minutes = Number('0' + minutes)) : minutes
    String(seconds).length < 2 ? (seconds = Number('0' + seconds)) : seconds
    const yyyyMMddHHmmss = `${year}${month}${day}${hour}${minutes}${seconds}`
    return yyyyMMddHHmmss
  },

  /* ============================================== 【Navigate】导航 START ============================================== */

  /**
   * 导航跳转处理-跳定制
   * @param {跳转表ID} id
   * @param {跳转打开的方式} eventType
   * @param {跳转的主表模块} moduleName
   * @param {跳转的主表标题} labelName
   * @param {扩展数据对象} exendObj
   * @param {Boolean} isback，返回是否刷新列表，默认true
   */
  navigateMain(
    id,
    eventType,
    moduleName,
    labelName,
    exendObj = {},
    isback = true
  ) {
    let _labelName = labelName
    if (!labelName.includes('.')) {
      _labelName = labelName
    } else {
      _labelName = $it(`${labelName}`)
    }
    R3.store.commit(`customize/${eventType}`, {
      id: id,
      type: 'action',
      name: moduleName,
      label: _labelName, // 订单管理
      back: isback,
      query: Object.assign({
        id: id,
        tabTitle: $it(`${labelName}`), // 订单管理
        ...exendObj,
      }),
    })
  },

  /**
   * 9个参数
   * eg:
        tabJump(0, -1, 1, 'PM_C_PROM_ACTI_BATCH_ADD', { i8n: 1, tip: 'panel_label.batchAddPromotion' }, {}, 0)
   */
  tabJump(
    mutationType,
    id,
    type,
    tableName,
    labelName = { i8n: 1, tip: '' },
    exendObj = {},
    isback = 0,
    global,
    tableId
  ) {
    const label = labelName.i8n ? $i18n.t(`${labelName.tip}`) : labelName.tip; // 语言包有就走语言包，不存在则直接取
    let mutationArr = ['customize/TabOpen', 'customize/switchActiveTab', 'customize/TabClose', 'customize/TabHref'];
    if (global) mutationArr = ['global/tabOpen'];
    const muta = mutationArr[mutationType];
    let param = {};
    if (!global) {
      param = {
        id: id,
        type: 1 ? 'action' : type, // 传1则'action'
        name: tableName,
        label,
        back: Boolean(isback),
        query: Object.assign({
          id: id,
          tabTitle: label,
          ...exendObj,
        }),
      };
    } else {
      param = {
        id: id, // 该条数据ID
        type: 1 ? 'S' : type, // 传1则'S'
        tableName,
        tableId,
        back: Boolean(isback),
      };
      if (type == 'C') {
        param = {
          type,
          customizedModuleId: tableId,
          customizedModuleName: tableName,
          label,
          dynamicRoutingForCustomizePage: Boolean(isback),
        };
      }
    }
    R3.store.commit(muta, param)
  },

  /**
   * 导航跳转处理-跳标准
   * @param {Number|String} id，明细ID
   * @param {Number} tableId，主表ID
   * @param {String} eventType，跳转打开的方式(eg.'TabHref'/'TabOpen')
   * @param {String} actionType，跳转类型(eg.'C'/'S')
   * @param {String} moduleName，模块名/tableName
   * @param {String} labelName，展示名
   * @param {Object} exendObj，拓展路由参数
   * @param {Boolean} isback，返回是否刷新列表，默认false
   */
  navigateStandard(
    id,
    tableId,
    eventType,
    actionType,
    moduleName,
    labelName,
    exendObj = {},
    isback = false
  ) {
    R3.store.commit(`global/${eventType}`, {
      type: actionType,
      tableName: moduleName,
      label: $i18n.t(`${labelName}`),
      tableId: tableId,
      id: id,
      query: Object.assign({
        id: id,
        ptitle: $i18n.t(`${labelName}`),
        tabTitle: $i18n.t(`${labelName}`),
        tableName: moduleName,
        back: isback,
        ...exendObj,
      }),
    })
  },

  /**
   * 关闭当前tab
   * @param _self 指向当前this
   */
  tabCloseAppoint(_self) {
    let obj = null
    if (_self.label && _self.routeFullPath) {
      // 传入的是当前tab的对应的数据对象
      obj = _self
    } else {
      // 传入的是this实例
      const arr = _self.$store.state.global.openedMenuLists
      const { fullPath } = _self.$route;
      obj = arr.find( i => i.routeFullPath == fullPath) || {}
    }
      R3.store.commit('global/tabCloseAppoint', obj)
    /* // 有bug:
    const { fullPath } = _self.$route;
    const { keepAliveModuleName, tableName } = _self.$store.state.global.activeTab;
    R3.store.commit('global/tabCloseAppoint', {
      routeFullPath: fullPath,
      stopRouterPush: true,
      keepAliveModuleName,
      tableName
    });
     */
  },

  /**
   * @param {*} _self
   * @param {*} defaultHeight
   */
  tabHref(_self, params, extendObj = {}) {
    // 返回--要传固定id
    let selection = [];
    if (!_self.vueAgTable) {
      selection = _self.$refs.agGridChild.AGTABLE.getSelect();
    } // 获取勾行数据;
    let id = params.id;
    if (params.id === 'id') {
      id = selection[0].ID;
    }
    if ((selection.length != 1 && params.id !== '-1') || (selection.length != 1 && params.cloneReturnGoodId)) {
      _self.$Message.warning($i18n.t('tip.zm'))
      return;
    }
    _self.$store.commit('customize/TabHref', {
      id: id,
      type: params.type ? params.type : 'action',
      name: params.name, // 文件名
      label: params.label, // tab中文名
      query: Object.assign({
        id: id,
        tabTitle: params.label, //  tab名
        ...extendObj
      })
    });
  },

  /* ============================================== 【Navigate】导航 END ============================================== */

  /* ============================================== 【Page】分页 START ============================================== */

  /**
   * 共用对象
   */
   pageConfig: {
    // 设置总条数
    total: 0,
    // 条数
    pageSize: 50,
    // 页数
    current: 1,
    pageSizeOpts: [50, 200, 500, 2000]
  },

  /**
   * 适用于前端分页
   * @method 分页初始化方法
   * @param {Array} sumData 总数据
   * @param {Object} config 分页的配置（含有current（页数）、pageSize（每页个数））
   * @returns {Object} data: 当前页数据；config: 分页的配置
  */
  pagingInit(sumData, config) {
    const sumTableData = JSON.parse(JSON.stringify(sumData)); // 所有数据
    let listData = [];
    const dataConfig = Object.assign({}, config);
    const pageSize = dataConfig.pageSize;
    const start = (dataConfig.current - 1) * pageSize;
    const end = start + pageSize;
    const dialogTableConfigData = sumTableData.slice(start, end);
    if (dialogTableConfigData.length === 0) {
      // 当前页都被删除
      if (dataConfig.current === 1) {
        // 当前页为第一页
        listData = [];
      } else {
        // 当前页不为第一页
        listData = sumTableData.slice(start - pageSize, end - pageSize);
        dataConfig.current--;
      }
    } else {
      listData = dialogTableConfigData;
    }
    return {
      data: listData,
      config: dataConfig
    };
  },

  /* ============================================== 【Page】分页 END ============================================== */

  /* ============================================== 【Object】 START ============================================== */

  /**
   * 含有部分相同属性的两个对象快速赋值法
   * 对于相同的key, 用源对象覆盖目标对象
   * @param {Object} target 目标对象
   * @param {Object} origin 源对象
   */
  intersectFormValue(target, origin) {
    const originKeys = Object.keys(origin)
    Object.keys(target).forEach((key) => {
      if (originKeys.includes(key)) {
        if (typeof origin[key] == 'object') {
          target[key] = JSON.parse(JSON.stringify(origin[key]))
        } else {
          target[key] = origin[key]
        }
      }
    })
  },

  /**
   * 获取表单字段的配置
   * @param {Object} formConfig 表单配置
   * @param {String} field 字段名称
   */
  queryForm(formConfig, field) {
    return formConfig.formData.find((item) => [
      item.colname, item.value, item.itemdata && item.itemdata.colname
    ].includes(field));
  },

  // 当post请求content-Type: application/x-www-form-urlencoded时，需要将JSON参赛转换成如下函数输入的形式。
  urlSearchParams(data){
    const params = new URLSearchParams();
    Object.keys(data).forEach((key) => {
      const dataType = Object.prototype.toString.call(data[key]);
      if (dataType === '[object Object]' || dataType === '[object Array]') {
        data[key] = JSON.stringify(typeof data[key] === 'string' ? data[key].trim() : data[key]);
      }
      params.append(key, data[key]);
    });
    return params;
  },
  /* ============================================== 【Object】 END ============================================== */

  /* ============================================== 【Date】日期 START ============================================== */

  standardTimeConversiondateToStr(val) {
    let tempVal = val || '';
    const dateTime = new Date(tempVal);
    const year = dateTime.getFullYear();
    let month = dateTime.getMonth() + 1; // js从0开始取
    let date = dateTime.getDate();
    let hour = dateTime.getHours();
    let minutes = dateTime.getMinutes();
    let second = dateTime.getSeconds();
    if (month < 10) {
      month = `0${month}`;
    }
    if (date < 10) {
      date = `0${date}`;
    }
    if (hour < 10) {
      hour = `0${hour}`;
    }
    if (minutes < 10) {
      minutes = `0${minutes}`;
    }
    if (second < 10) {
      second = `0${second}`;
    }
    return `${year}-${month}-${date} ${hour}:${minutes}:${second}`;
  },

  // 针对日期组件：数据标准时间转成 yyyy-mm-dd hh:mm:ss
  standardTimeConversion(val) {
    const d = new Date(val);
    const datetime = `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()} `;
    return datetime;
  },

  /**
   * @Descroption 将日期变量转换为指定格式的日期
   * @Author 洪艺安
   * @param date
   * @param fmt
   * @returns {*}
   */
  getFormatDate(date, fmt) {
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        `${date.getFullYear()}`.substr(4 - RegExp.$1.length)
      );
    }
    const o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'H+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds(),
    };
    for (const k in o) {
      if (new RegExp(`(${k})`).test(fmt)) {
        const str = `${o[k]}`;
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length === 1 ? str : `00${str}`.substr(str.length)
        );
      }
    }
    return fmt;
  },

  compareDate(date1, date2) {
    const d1 = new Date(date1);
    const d2 = new Date(date2);
    if (d1.getTime() > d2.getTime()) {
      return true;
    }
    return false;
  },

  /** 日期原型扩展
   * 日期格式转化函数
   */
  Format(self, fmt) {
    const o = {
      'M+': self.getMonth() + 1, // 月份
      'd+': self.getDate(), // 日
      'h+': self.getHours(), // 小时
      'm+': self.getMinutes(), // 分
      's+': self.getSeconds(), // 秒
      'q+': Math.floor((self.getMonth() + 3) / 3), // 季度
      S: self.getMilliseconds(), // 毫秒
    };
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        `${self.getFullYear()}`.substr(4 - RegExp.$1.length)
      );
    }
    for (const k in o) {
      if (new RegExp(`(${k})`).test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length === 1 ? o[k] : `00${o[k]}`.substr(`${o[k]}`.length)
        );
      }
    }
    return fmt;
  },

  /**
   * 增加添加指定单位的时间值
   * @param   dt   日期 可以是一个时间类型或者一个时间格式的字符串
   * @param   num  时间隔值
   * @param   unit 时间间隔单位： S(毫秒) s(秒) m(分) h(小时) d(天) M(月) y(年)
   */
  dateAdd(dt, num, unit) {
    dt = this.convert(dt);
    switch (unit) {
      case 'S':
        return new Date(dt.getTime() + num);
      case 's':
        return new Date(dt.getTime() + num * 1000);
      case 'm':
        return new Date(dt.getTime() + num * 60000);
      case 'h':
        return new Date(dt.getTime() + num * 3600000);
      case 'd':
        return new Date(dt.getTime() + num * 86400000);
      case 'M':
        return new Date(
          dt.getFullYear(),
          dt.getMonth() + num,
          dt.getDate(),
          dt.getHours(),
          dt.getSeconds(),
          dt.getMilliseconds()
        );
      case 'y':
        return new Date(
          dt.getFullYear() + num,
          dt.getMonth(),
          dt.getDate(),
          dt.getHours(),
          dt.getSeconds(),
          dt.getMilliseconds()
        );
      default:
        return dt;
    }
  },

  /**
   * 给指定时间累加毫秒
   * @param dt 待累加毫秒的时间类型数据(可以是时间类型数据或者时间格式的字符串)
   * @param milliSeconds 累加毫秒
   */
  addMilliseconds(dt, milliSeconds) {
    return this.dateAdd(dt, milliSeconds, 'S');
  },

  /**
   * 给指定时间累加秒
   * @param dt):待累加秒的时间
   * @param seconds):累加秒
   */
  addSeconds(dt, seconds) {
    return this.dateAdd(dt, seconds, 's');
  },

  /**
   * 给指定时间累加分钟
   * @param dt):待累加分钟的时间(可以是时间类型数据或者时间格式的字符串)
   * @param minutes):累加分钟
   */
  addMinutes(dt, minutes) {
    return this.dateAdd(dt, minutes, 'm');
  },

  /**
   * 给指定时间累加小时
   * @param dt):待累加小时的时间(可以是时间类型数据或者时间格式的字符串)
   * @param hours):累加小时
   */
  addHours(dt, hours) {
    return this.dateAdd(dt, hours, 'h');
  },

  /**
   * 给指定时间累加天数
   * @param dt):待累加天数的时间(可以是时间类型数据或者时间格式的字符串)
   * @param days):累加天数
   */
  addDays(dt, days) {
    return this.dateAdd(dt, days, 'd');
  },

  /**
   * 时间转换函数
   * @param   maybe 时间类型，或者时间类型字符串，或者毫秒数字
   *
   * @example
   *         var Dante = require('dantejs');
   *         Dante.Date.convert('2016-10-22'); > Date()
   */
  convert(maybe) {
    if (this.isDate(maybe)) {
      return maybe;
    }
    if (strUtil.IsString(maybe) && Number.isNaN(maybe)) {
      maybe = maybe.replace(/-/g, '/');
      const values = maybe.match(/(\d+)+/g);
      return new Date(
        values[0],
        parseInt(values[1]) - 1,
        values[2] || '',
        values[3] || '',
        values[4] || '',
        values[5] || '',
        values[6] || ''
      );
    }
    if (strUtil.IsString(maybe)) {
      maybe = `${maybe.slice(0, 4)}-${maybe.slice(4, 6)}-${maybe.slice(6, 8)}`;
      maybe = maybe.replace(/-/g, '/');
      const values = maybe.match(/(\d+)+/g);
      return new Date(
        values[0],
        parseInt(values[1]) - 1,
        values[2] || '',
        values[3] || '',
        values[4] || '',
        values[5] || '',
        values[6] || ''
      );
    }
    return new Date(Number(maybe));
  },

  /**
   * 判断传入值是否为Date数据类型
   * @param date  待判断的值
   */
  isDate(date) {
    return Object.prototype.toString.call(date) === '[object Date]';
  },

  // 标准时间转时间格式
  FromDates(time) {
    const date = new Date(time);
    const Y = `${date.getFullYear()}-`;
    const M = `${date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1}-`;
    const D = `${date.getDate()} `;
    // const h = `${date.getHours()}:`;
    // const m = `${date.getMinutes()}:`;
    // const s = date.getSeconds();
    return Y + M + D;
  },

  // 时间戳转换为日期
  timestampToTime(timestamp) {
    const a = (`${timestamp}`).length;
    const date = a == 13 ? new Date(timestamp) : new Date(timestamp * 1000); // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
    const Y = `${date.getFullYear()}-`;
    const M = `${date.getMonth() + 1 < 10
      ? `0${date.getMonth() + 1}`
      : date.getMonth() + 1}-`;
    const D = `${date.getDate()} `;
    const h = `${date.getHours()}:`;
    const m = `${date.getMinutes()}:`;
    const s = date.getSeconds();
    return Y + M + D + h + m + s;
  },

  // 字符串转时间格式
  DatesTime(time) {
    const date = new Date(time);
    const Y = `${date.getFullYear()}-`;
    const M = `${date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1}-`;
    const D = `${date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()} `;
    const h = `${date.getHours() < 10 ? `0${date.getHours()}` : date.getHours()}:`;
    const m = `${date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes()}:`;
    const s = (date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds());
    return Y + M + D + h + m + s;
  },

  // 数组标准时间转换成yyyy-mm-dd格式
  getTimesValue(time) {
    let timeValue = '';
    const dateone = new Date(time[0]).toJSON();
    const datetwo = new Date(time[1]).toJSON();
    const dateTimeOne = new Date(+new Date(dateone) + 8 * 3600 * 1000)
      .toISOString()
      .replace(/T/g, ' ')
      .replace(/\.[\d]{3}Z/, '');
    const dateTimeTwo = new Date(+new Date(datetwo) + 8 * 3600 * 1000)
      .toISOString()
      .replace(/T/g, ' ')
      .replace(/\.[\d]{3}Z/, '');
    timeValue = `${dateTimeOne}~${dateTimeTwo}`;

    if (timeValue === '1970-01-01 08:00:00~1970-01-01 08:00:00') {
      timeValue = '';
    }
    return timeValue;
  },

  /**
   * 日期 format
   * @method 日期转换
   * @param {Date} newDate {Object Date}
   * @param {String} format {String} 示例: yyyy-MM-dd hh:mm:ss
   */
  dateFormat(newDate, format) {
    const e = {
      'M+': newDate.getMonth() + 1,
      'd+': newDate.getDate(),
      'h+': newDate.getHours(),
      'm+': newDate.getMinutes(),
      's+': newDate.getSeconds()
    };
    if (/(y+)/.test(format)) {
      format = format.replace(RegExp.$1, (`${newDate.getFullYear()}`).substr(4 - RegExp.$1.length));
    }
    for (const k in e) {
      if (new RegExp(`(${k})`).test(format)) {
        format = format.replace(RegExp.$1, (RegExp.$1.length == 1) ? (e[k]) : ((`00${e[k]}`).substr((`${e[k]}`).length)));
      }
    }
    return format;
  },

  /**
   * 获取当前时间
   */
  getCurrentTime() {
    let startTime = this.Format(new Date(), 'yyyy-MM-dd 23:59:59');
    let endDay = this.addDays(new Date(), -7);
    let endTime = this.Format(endDay, 'yyyy-MM-dd 00:00:00');
    return [startTime, endTime];
  },

  /**
   * 获取n天后的日期
   */
   getDate(index) {
    const date = new Date(); // 当前日期
    const newDate = new Date();
    newDate.setDate(date.getDate() + index);
    const time = `${newDate.getFullYear()}-${newDate.getMonth() + 1}-${newDate.getDate()}`;
    return time;
  },

  /**
   * 获取n天前的日期
   */
  getDateOld(index) {
    const date = new Date(); // 当前日期
    const newDate = new Date();
    newDate.setDate(date.getDate() - index);
    const mon = newDate.getMonth() + 1;
    const day = newDate.getDate();
    const time = `${newDate.getFullYear()}-${mon < 10 ? `0${mon}` : mon}-${day < 10 ? `0${day}` : day}`;
    return time;
  },

  /**
   * 获取两个字符串日期相差天数
   */
  dateDiff(startDate, endDate) {
    let aDate;
    aDate = startDate.split('-');
    const oDate1 = new Date(`${aDate[1]}-${aDate[2]}-${aDate[0]}`);
    aDate = endDate.split('-');
    const oDate2 = new Date(`${aDate[1]}-${aDate[2]}-${aDate[0]}`);
    const iDays = parseInt(Math.abs(oDate1 - oDate2) / 1000 / 60 / 60 / 24);
    return iDays;
  },

  /**
   * 结束时间，只选择日期未选择时间的情况下，时间默认23:59:59
   * @param {Date|String} newEndTime 改变后的结束时间
   * @param {Date|String} oldEndTime 改变前的结束时间
   * @returns 返回处理后的结束时间
   */
  defaultEndTime(newEndTime, oldEndTime) {
    let isNewDate = Object.prototype.toString.call(newEndTime) == '[object Date]'
    let isOldDate = Object.prototype.toString.call(oldEndTime) == '[object Date]'
    let [newDate, newTime] = (isNewDate
      ? this.getFormatDate(newEndTime, 'yyyy-MM-dd HH:mm:ss') : newEndTime).split(' ')
    let [oldDate, oldTime] = (oldEndTime && isOldDate
      ? this.getFormatDate(oldEndTime, 'yyyy-MM-dd HH:mm:ss') : oldEndTime || '').split(' ')

    let time = `${newDate} ${newTime}`
    if (time != `${oldDate} ${oldTime}`
      && newDate != oldDate
      && '00:00:00' == newTime
    ) {
      time = `${newDate} 23:59:59`
    }
    return time
  },

  /* ============================================== 【Date】日期 END ============================================== */

  /* ============================================== 【Number】START ============================================== */

  // 加法函数
  accAdd(arg1, arg2) {
    let r1; let r2; let m; let c;
    arg1 = arg1 || 0;
    arg2 = arg2 || 0;
    try {
      r1 = arg1.toString().split('.')[1].length;
    } catch (e) {
      r1 = 0;
    }
    try {
      r2 = arg2.toString().split('.')[1].length;
    } catch (e) {
      r2 = 0;
    }
    c = Math.abs(r1 - r2);
    m = Math.pow(10, Math.max(r1, r2));
    if (c > 0) {
      const cm = 10 ** c;
      if (r1 > r2) {
        arg1 = Number(arg1.toString().replace('.', ''));
        arg2 = Number(arg2.toString().replace('.', '')) * cm;
      } else {
        arg1 = Number(arg1.toString().replace('.', '')) * cm;
        arg2 = Number(arg2.toString().replace('.', ''));
      }
    } else {
      arg1 = Number(arg1.toString().replace('.', ''));
      arg2 = Number(arg2.toString().replace('.', ''));
    }
    return (arg1 + arg2) / m;
  },

  // 減法函數
  accSub(arg1, arg2) {
    let r1; let r2;
    arg1 = arg1 || 0;
    arg2 = arg2 || 0;
    try {
      r1 = arg1.toString().split('.')[1].length;
    } catch (e) {
      r1 = 0;
    }
    try {
      r2 = arg2.toString().split('.')[1].length;
    } catch (e) {
      r2 = 0;
    }
    const m = 10 ** Math.max(r1, r2); // last modify by deeka //动态控制精度长度
    // const n = (r1 >= r2) ? r1 : r2;
    return ((arg1 * m - arg2 * m) / m).toFixed(4);
  },

  // 乘法
  accMul(arg1, arg2) {
    let m = 0;
    arg1 = arg1 || 0;
    arg2 = arg2 || 0;
    const s1 = arg1.toString();
    const s2 = arg2.toString();
    if (s1.split('.')[1]) {
      m += s1.split('.')[1].length;
    }
    if (s2.split('.')[1]) {
      m += s2.split('.')[1].length;
    }
    return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / (10 ** m);
  },

  // 除法
  accDiv(arg1, arg2) {
    let t1 = 0; let t2 = 0;
    arg1 = arg1 || 0;
    arg2 = arg2 || 0;
    try {
      t1 = arg1.toString().split('.')[1].length;
    } catch (e) {
      console.log(e);
    }
    try {
      t2 = arg2.toString().split('.')[1].length;
    } catch (e) {
      console.log(e);
    }
    const r1 = Number(arg1.toString().replace('.', ''));
    const r2 = Number(arg2.toString().replace('.', ''));
    // return (r1 / r2) * Math.pow(10, t2 - t1);
    return (r1 / r2) * (10 ** (t2 - t1));
  },

  /**
   * 四舍五入改进
   * num表示需要四舍五入的小数
   * s表示需要保留几位小数
   */
  toFixed(num, s) {
    const times = 10 ** s;
    let des = num * times + 0.5;
    des = parseInt(des, 10) / times;
    return `${des}`;
  },

  /**
   * 保留小数点几两位 不足自动补0
   *  @param {Number\String}
   */
  floatNumber(num) {
    num = typeof num === 'number' ? num.toString() : num;
    if (num.includes('.')) {
      let b = num.split('.')
      if (b[1].length == 1) {
        b = b.join('.')
        b += '0'
        num = b
      } else if (b[1].length > 2) {
        let isZero = b[0].charAt(0) == '0';
        let num_length = isZero ? 2 : b[0].length + 2;
        if(b[0].includes('-')) num_length = num_length - 1;
        b = Number(b.join('.')).toPrecision(num_length)
        num = b;
      }
    } else {
      num += '.00'
    }
    return num
  },

  /* ============================================== 【Number】END ============================================== */

  /* ============================================== 【Array】START ============================================== */

  // 数组对象根据子元素某各个key合并分组
  sonList(arr, key) {
    return arr.map((item) => item[key])
  },

  /**
   * 扩展Array方法, 去除数组中空白数据
   */
  notempty(val) {
    return val.filter(function (s) {
      return s && s.toString().trim()
    })
  },

  /**
   * 获取两个数组对象的差集
   * @param allArr：全数组
   * @param partArr：缺省数组
   * @key {ECODE} 根据key来做求差集
   */
   getDifferentArr(allArr = [], partArr = [], key) {
    const differentArr = [...allArr].filter((x) =>
      [...partArr].every((y) => y[key] !== x[key])
    )
    return differentArr
  },

  /**
   * 获取两个数组对象的交集
   * @param Arr1 数组1
   * @param Arr2 数组2
   * @key {ID} 根据key来做求交集
   */
  getUnionArr(Arr1 = [], Arr2 = [], key) {
    const unionArr = [...Arr1].filter((x) =>
      [...Arr2].some((y) => y[key] === x[key])
    )
    return unionArr
  },

  /**
   * 数组去重 ps:工作台专用
   */
  workArrHeavy(arr1, arr2) {
    if (arr1 && arr2) {
      for (let i = 0; i < arr1.length; i++) {
        for (let j = 0; j < arr2.length; j++) {
          if (arr1[i].key === arr2[j].key) {
            arr1[i].value = arr2[j].value;
            break;
          }
        }
      }
      return arr1;
    }
    return [];
  },

  /* ============================================== 【Array】END ============================================== */

  /* ============================================== 【DOM】START ============================================== */

  /**
   * 设置表格高度
   * @param _self 指向当前this
   * @param defaultHeight 指向当前this
   * 获取agTable高度
   * 通过 totalHeight 节点
   */
   setTableHeight(_self, defaultHeight) {
    const contentHeight = document.getElementById('content').clientHeight;
    // 获取需要除了agTable之外的节点
    const arr = document.getElementsByClassName('totalHeight');
    if (!arr.length) return // 解决促销换ag后报错
    let sumHeight = 34 + defaultHeight;
    Object.getOwnPropertyNames(arr).forEach(item => {
      sumHeight += parseInt(arr[item].clientHeight);
    });
    const tableHeight = `${contentHeight - sumHeight}px`;
    if (_self.$refs.agGridChild1) {
      _self.tabConfig.forEach(item => {
        item.agTableConfig.tableHeight = tableHeight;
      });
    } else {
      _self.agTableConfig.tableHeight = tableHeight;
    }
    const agTableDom = document.getElementsByClassName('ag-theme-balham')[0];
    if (agTableDom) {
      agTableDom.style.height = tableHeight;
    }
  },

  /**
   * 计算表格高度
   */
  onresizes(_self, defaultHeight) {
    let option = () => { };
    // 获取当前主表名
    const tableName = _self.$route.params.customizedModuleName;
    // 匹配当前的定制界面执行当前逻辑
    switch (tableName) {
      case 'PAYABLEADJUSTMENTLIST':// 赔付单
      case 'RETURNGOODLIST': // 退换货单
      case 'RETURNSTOREAGELIST':// 退货入库
      case 'ORDERMANAGER':// 零售发货单
        option = () => {
          if (tableName == 'ORDERMANAGER' && _self.iconDownIcon === 'ark-icon iconfont iconios-arrow-down') {
            // 判断 如果不是高级搜索 自适应高度
            this.setTableHeight(_self, defaultHeight);
          } else if (tableName != 'ORDERMANAGER') {
            this.setTableHeight(_self, defaultHeight);
          }
        };
        break;
      case 'PROMACTIQUERYLIST':// 促销活动
        option = () => {
          this.setTableHeight(_self, 100);
          const agGridChild = `agGridChild${Number(_self.activeName) + 1}`;
          _self.$refs[`${agGridChild}`][0].agGridTable(_self.tabConfig[_self.activeName].agTableConfig.columnDefs, _self.tabConfig[_self.activeName].agTableConfig.rowData);
        };
        break;
    }
    $(window).on('resize', option);
  },

  /**
   * 销毁resize方法
   */
  removeOnresize() {
    //  移除监听屏幕变化方法 js
    $(window).off('resize');
  },

  /**
   * 设置局部loading
   * @loading 是否生成loading
   */
  setLoading(loading = false) {
    const loadingParentDom = document.getElementsByClassName('ark-modal-body')[0];
    let loadingDom = document.getElementsByClassName('vue-loading')[0];
    if (loadingDom) {
      loadingParentDom.removeChild(loadingDom);
    }
    loadingDom = document.createElement("div");
    loadingParentDom.appendChild(loadingDom);
    const loadingChildDom = document.createElement("div");
    loadingDom.appendChild(loadingChildDom);
    if (loading) {
      loadingDom.setAttribute('class', 'vue-loading');
      loadingChildDom.setAttribute('class', 'R3-Loading loader');
    } else {
      loadingParentDom.removeChild(loadingDom);
    }
  },

  /**
   * 导出
   * src 导出路径
   */
  downloadUrlFile(url) {
    const self = this;
    const domFrame = window.parent.document.getElementById('downLoadListFrame');
    if (domFrame != null) {
      window.parent.document.body.removeChild(domFrame);
    }
    const downloadFile = {};
    if (typeof downloadFile.iframe === 'undefined') {
      const iframe = document.createElement('iframe');
      iframe.setAttribute('id', 'downLoadListFrame');
      self.addEvent('load', iframe, () => {
        self.iframeLoad(iframe);
      });
      iframe.src = url;
      iframe.style.display = 'none';
      downloadFile.iframe = iframe;
      document.body.appendChild(downloadFile.iframe);
      setTimeout(() => {
        iframe.src = '';
      }, 1000);
    }

    // const eleLink = document.createElement('a');
    // eleLink.setAttribute('href', src);
    // eleLink.style.display = 'none';
    // document.body.appendChild(eleLink);
    // eleLink.click();
    // document.body.removeChild(eleLink);

    // const download_file = {};
    // if (typeof (download_file.iframe) === 'undefined') {
    //   const iframe = document.createElement('iframe');
    //   download_file.iframe = iframe;
    //   document.body.appendChild(download_file.iframe);
    // }
    // download_file.iframe.src = src;
    // download_file.iframe.style.display = 'none';
  },

  // 判断iframe的src
  iframeLoad(iframe) {
    const src = iframe.src ? iframe.src : iframe.contentWindow.locatiion.href;
    console.log('src::', src);
  },

  // 调用方法时绑定iframe的load事件
  addEvent(eventName, element, fn) {
    if (element.attachEvent) element.attachEvent(`on${eventName}`, fn);
    else element.addEventListener(eventName, fn, false);
  },
  /* ============================================== 【DOM】END ============================================== */
  /* ============================================== 【FILE】START ============================================== */
  //
  exportModules(requireFiles, useSubdirectories) {
    return requireFiles.keys().reduce((exportModules, modulePath) => {
      let file = requireFiles(modulePath)
      let moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
      // 文件名转驼峰
      if (moduleName.includes('.')) {
        moduleName = moduleName.split('.').map((i,index) => {
          return index === 0 ? i : i.charAt(0).toUpperCase() + i.slice(1)
        }).join('')
      }

      // 处理检索子文件夹
      if (useSubdirectories) {
        moduleName = `R3${ file.default.name.replace(/(_|-)/g, '') }`
      }
      exportModules[moduleName] = file.default || file
      return exportModules
    }, {})
  },


  /**
   * 数组去重 (根据数组里对象中某个key去重)
   * @param data
   * @param key
   * @returns {*|[]}
   */
  uniqueFun(data,key) {
    const  obj = {};
    let  arr = [];
    arr = data.reduce(function (item, next) {
      obj[next[key]] ? '' : obj[next[key]] = true && item.push(next);
      return item;
    }, []);
    return arr
  },

  gateWayPrefix: {
    basicData: '/r3-cp',
    commodityCenter: '/r3-ps',
    orderCenter: '/r3-oc-oms',
  },

  //--------------工具方法区--------------------------

  initForm(self, param, myForm) {
    // const self = this;
    // console.log(data);
    /* const param = {
      TABLE: self.tablename,
      FOLD: fold,
    }; */
    let da, fD = [], fV = {}, fR = {};
    return vm.service.orderCenter.initList(param).then(res => {
      const { data: { code, data } } = res;
      if (code === 0) {
        if (data.ZIP) {
          console.error("当前数据格式为'ZIP',不支持!")
          return Promise.reject(data)
        } else {
          da = data.DATA;
          return da
        }
      }
    }).then(form => {
      /**
       * 1. style
       * 2. width
       * 3. regx
       */
      const ordinary = []; // 普通控件
      const fkStylt = ['drp', 'mrp', 'FK_TABLE']; // 外键等复杂控件
      form.forEach((ele, i) => {
        let item;
        const key = ele.NAME;
        const myEle = myForm.find(it => it.colname == key);
        if (ordinary.includes(ele.DISPLAY)) {
          item = {
            colname: key, // 控件key
            style: 'input', // 控件类型
            label: ele.DESC, // 控件label名称
          }
          Object.assign(item, myEle);
          fV[key] = ele.defval || ''; // 生成formValue
          if (ele.isnotnull) { // 生成必填ruleValidate
            fR[item.colname] = [
              {
                required: true,
                message: ' ',
              },
            ]
          }
        } else {
          Object.assign(ele, myEle);
          item = {
            colname: key,
            itemdata: ele,
          }
        }
        fD.push(item); // 生成formData结构
      });
      const formCon = {
        fD,
        fV,
        fR
      }
      const res = {
        res: da,
        formCon,
      }
      return Promise.resolve(res)
    })
    // return formCon
    // 配置必填**************************************************
    // self.formConfig.ruleValidate = {
    //   ORDER_TAG: [{ required: true, message: ' ', trigger: 'blur' }],
    // };
  },

  //请求主体处理
  /*
    callback不定参, 做参数解构;
    callbackType: callback类型标记, callbackFun;
    callbackType : all 全部替换, part 局部替换;
   */
  /**
   * 统一发请求
   * @self {Object} 当前实例
   * @serviceUrl {String} eg."com.queryList"
   * @params {Object} 该接口的请求参数
   * @callback  {Array} 其余参数解构成的数组
   * @callbackType {String} 用于判断何时走回调函数
   * @callbackFun {Funtion} 回调函数，具体处理接口返回的res的方法
   */
  serviceHandler(self, serviceUrl, params, ...callback) {
    const ApiUrl = serviceUrl.split('.')
    self.service[ApiUrl[0]]
    [ApiUrl[1]](params)
      .then((res) => {
        let [callbackType, callbackFun] = callback
        console.log('args', callbackType)
        if (callbackType == 'all') {
          callbackFun(res)
        } else {
          if (res.data.code === 0) {
            if (callbackFun) {
              callbackFun(res)
            } else {
              $utils.msgTips(self, 'success', '取消成功', 0)
              self.selection = []
              self.query()
            }
          } else {
            // this.tipShow('error', self, res);
            $utils.tipShow(
              'confirm',
              self,
              res,
              `订单取消成功${res.data.data.SUCCESS_COUNT}条失败${res.data.data.ERROR_COUNT}条!`,
              function (h) {
                //因为后端复用列列表详情界面的取消接口,需要区分
                return h('Table', {
                  props: {
                    columns: [
                      {
                        title: $it('tL.serialNo'), // 序号
                        key: 'INDEX',
                      },
                      {
                        title: $it('fL.billNo'), // 单据编号
                        key: 'BILL_NO',
                      },
                      {
                        title: $it('fL.e0'), // 失败原因
                        key: 'RESULT_MSG',
                      },
                    ],
                    data: res.data.data.CANCEL_ORDER_ERROR_INFOS,
                  },
                })
              }
            )
          }
        }
      })
      .finally(() => {
        self.btnConfig.loading = false
      })
  },

  modalShow(self, tips, okKey, data, ...callback) {
    self.$Modal.info({
      title: $it('mT.tips'), // 提示
      content: $it(`tip.${tips}`),
      mask: true,
      showCancel: true,
      onOk: () => {
        let [callbackType, callbackFun] = callback
        this.serviceHandler(self, okKey, data, callbackType, callbackFun)
      },
      onCancel: () => {
        self.$emit('closeActionDialog', false)
      },
    })
  },
  /**
   * 按钮权限请求方法getPermissions：
   * @self {object} 指向当前实例
   * @arrry {string} 当前按钮配置的name，eg: 'btnConfig'
   * @param {string} 用于请求接口的传参，目前是String类型。待扩展成对象类型，便于支持同名不同按钮配置的页面，如新增和详情同一页面时
   * @param {Boolean} isIndependent 单对象页面必传true
   * @returns
   */
  getPermissions(self, array, params, isIndependent) {
    const query = {
      TABLE: params.table || params.TABLE,
      TYPE: params.type || params.TYPE,
    }
    const serviceId = params.serviceId || params.SERVICEID || '';
    let data, btnArr = [];
    if (!isIndependent && self[array] == undefined) return
    if (self[array] != undefined) btnArr = self[array].buttons || [];
    const show_iconbj_setup = ['ORDERMANAGER' , 'OC_B_RETURN_ORDER']; //储存允许设置按钮展示的页面集;
    return new Promise(async (resolve) => {
      const res = await self.service.common.fetchActionsInCustomizePage(query, { serviceId });
      let result = res.data.data.ZIP || res.data.data.DATA || [] //未压缩情况下数据获取
      data = JSON.parse(JSON.stringify(result))
      if (res.data.code === 0) {
        const a = [], c = [];
        if (!btnArr.length) {
          resolve(data);
          return
        }
        self[array].buttons.forEach((item) => {
          // 设置、收藏等图标按钮的配置
          if (!item.text && item.icon ) {
            if(item.icon !== 'iconfont iconbj_setup'){
              a.push(item);
            }else if(show_iconbj_setup.includes(self.$route.params.customizedModuleName)){
              a.push(item)
            }
          }
        })
        if (isIndependent) {
          result = result.ACTIONS;
        }
        result.forEach((element) => {
          // 有下拉项的处理
          if (element.child) {
            this.buttonChild(element, self[array].buttons, c)
          }
          // 普通btn（无child）的处理
          self[array].buttons.forEach((btn) => {
            if (!btn.webname) {
              console.log('btnConfig no webname !', btn);
              return
            }
            if (btn.webname == element.webname) {
              btn.webid = element.webid
              btn.text = element.webdesc
              c.push(btn)
            }
          })
        })
        self[array].buttons.forEach((btn) => {
          if (btn.webname == 'fix_back') {
            btn.text = $it("btn.back");
            if (!c.some(it => it.webname == 'fix_back')) {
              c.push(btn)
            }
          }
        })
        if (btnArr.length) {
          self[array].buttons = [...c, ...a]
          self[array].loading = false;
        }
        resolve(data);
      }
    }).finally(e => {
      console.log('butConfig::', self[array]);
    });
    /*  self.service.common.fetchActionsInCustomizePage(query).then((res) => {
       let result = res.data.data.ZIP || res.data.data.DATA || [] //未压缩情况下数据获取
       independent = result
       if (isIndependent) {

         self[array] = JSON.parse(JSON.stringify(result));
         return independent
       } else {
         const a = []
         self[array].buttons.forEach((item) => {
           // 设置、收藏等图标按钮的配置
           if (!item.text && item.icon) {
             a.push(item);
             // if(show_iconbj_setup.includes(self.$route.params.customizedModuleName)){ //暂时不过滤任何图标按钮
             //   a.push(item)
             // }else if(item.icon !== 'iconfont iconbj_setup'){
             //   a.push(item);
             // }

           }
         })
         const c = []
         result.forEach((element) => {
           // 有下拉项的处理
           if (element.child) {
             this.buttonChild(element, self[array].buttons, c)
           }
           // 普通btn（无child）的处理
           self[array].buttons.forEach((btn) => {
             if (
               btn.webname == element.webname ||
               btn.webname.includes(element.webname)
             ) {
               btn.webid = element.webid
               btn.text = element.webdesc
               c.push(btn)
             }
           })
         })
         self[array].buttons = [...c, ...a]
       }
       self[array].loading = false
     }).catch(e => {
       if (self[array] != undefined) self[array].loading = false;
     }) */
  },

  /**
   * 版本2:按钮权限请求方法getBtnPermission：
   * @self {object} 指向当前实例
   * @cBtn {Array} 当前按钮配置的name，buttons数组的上一级。eg: 'btnConfig'
   * @param {string} 用于请求接口的传参，目前是String类型。待扩展成对象类型，便于支持同名不同按钮配置的页面，如新增和详情同一页面时
   * @param {Boolean} isIndependent 默认为单对象
   * @returns
   */
  getBtnPermission(self, cBtn, params, isIndependent=true) {
    const query = {
      TABLE: params.table || params.TABLE,
      TYPE: params.type || params.TYPE,
    }
    const serviceId = params.serviceId || params.SERVICEID || '';
    let data, btnArr = [];
    if (!isIndependent && self[array] == undefined) return
    return new Promise(async (resolve) => {
      const res = await self.service.common.fetchActionsInCustomizePage(query, { serviceId });
      let result = res.data.data.ZIP || res.data.data.DATA || [] //未压缩情况下数据获取
      if (isIndependent) {
        result = result.ACTIONS;
      }
      data = JSON.parse(JSON.stringify(result))
      if (res.data.code === 0) {
        cBtn.forEach(item=>{
          let key = item.split('.');
          let btnArr = self
          for (const i of key) {
            btnArr = btnArr[i]
          };
          const a = [], c = [];
        result.forEach((element) => {
          // 有下拉项的处理
          if (element.child) {
            this.buttonChild(element, btnArr.buttons, c)
          }
          // 普通btn（无child）的处理
          btnArr.buttons.forEach((btn) => {
            if (!btn.webname) {
              console.log('btnConfig no webname !', btn);
              return
            }
            if (btn.webname == element.webname) {
              btn.webid = element.webid
              btn.text = element.webdesc
              c.push(btn)
            }
            // if (btn.webname == 'fix_back') {
            //   btn.text = $it("btn.back");
            //   if (!c.some(it => it.webname == 'fix_back')) {
            //     c.push(btn)
            //   }
            // }
          })
        })
        if (btnArr.buttons.length) {
          btnArr.buttons = [...c, ...a]
          btnArr.loading = false;
        }

        })
        resolve(data);
      }
    }).finally(e => {
      // console.log('butConfig::', self[array]);
    });
  },

  buttonChild(ele, btns, arr) {
    const obj = {}
    const ar = []
    obj.menuText = ele.caption
    obj.dropDown = true
    ele.child.forEach((item) => {
      if (item.child) {
        this.buttonChild(item, btns, ar)
        return
      }
      btns.forEach((sItem) => {
        if (
          item.webname == sItem.webname ||
          sItem.webname.includes(item.webname)
        ) {
          sItem.webid = item.webid
          sItem.text = item.webdesc
          ar.push(sItem)
        }
      })
    })
    obj.menus = ar
    arr.push(obj)
  },

  // 字段选项组转换
  converSelect(val) {
    let list = val.map((item) => {
      return { label: item.limitdesc, value: item.limitval }
    })
    return list
  },

  /* ============================================== 2.0: ============================================== */

  /**
   * 获取字段选项组值/初始化下拉options(p/cs/getObject)
   *  @table 'PS_C_SKU' 表名
   *  @colArr ["PAY_TYPE"] select类型的字段 的colname/英文名 的集合
   *  @foldingName "基础信息" 折叠名称
   *  @formConfig this.formConfig 待修改的formConfig
   *  @return 返回this.formConfig.formData
   * */
  async getTypeList(table, colArr, foldingName, formConfig) {
    const fromdata = new FormData()
    let fD = formConfig.formData
    fromdata.append('table', table)
    fromdata.append('objid', -1)
    fromdata.append('omsT', +new Date())
    const res = await vm.service.common.getObject(fromdata)
    res.data.data.addcolums.forEach((item) => {
      if (item.parentdesc == foldingName) {
        item.childs.forEach((it) => {
          // it为接口返回的类似formData.Item的数据
          colArr.forEach((colArrItem) => {
            if (it.colname == colArrItem) {
              // 用colname来匹配需要的select类型的item
              fD.forEach((fDitem) => {
                // 赋值给options
                if (fDitem.colname === colArrItem) {
                  fDitem.options = it.combobox.map((i) => ({
                    label: i.limitdesc,
                    value: i.limitval,
                  }))
                }
              })
            }
          })
        })
      }
    })
    return fD
  },
  /**
   * @method 请求p/cs/getObject接口，初始化‘基础信息’Part的表单值
   * @table 主表表名
   * @id 明细ID
   */
  async getObject(table, id) {
    const fromdata = new FormData()
    fromdata.append('table', table)
    fromdata.append('objid', id)
    fromdata.append('omsT', +new Date())
    const {
      data: { code, data, message },
    } = await vm.service.common.getObject(fromdata)
    if (code != 0) {
      console.error('p/cs/getObject no data!')
      return false
    } else {
      // return data
      return new Promise(resolve => {
        resolve(data)
      })
    }
  },

  /* ============================================== 【Form】表单 START ============================================== */

  // 清空表单
  formEmpty(_this, form, notvalueArr = [], notdrpArr = []) {
    _this[form].formData.forEach((it) => {
      if (it.itemdata && !notdrpArr.includes(it.colname)) {
        it.itemdata.pid = '';
        it.itemdata.valuedata = '';
        it.itemdata.defaultSelectedMrp = []; // 针对dropSelect类型
        it.itemdata.dropValue = []; // 针对dropSelect类型
      }
    })
    for (const key in _this[form].formValue) {
      if (!notvalueArr.includes(key)) {
        _this[form].formValue[key] = ''
      }
    }
    return _this[form]
  },
  clear(_this, notvalueArr = [], notdrpArr = []) {
    _this.formData.forEach((it) => {
      if (it.itemdata && !notdrpArr.includes(it.colname)) {
        it.itemdata.pid = '';
        it.itemdata.valuedata = '';
        it.itemdata.defaultSelectedMrp = []; // 针对dropSelect类型
        it.itemdata.dropValue = []; // 针对dropSelect类型
      }
    })
    for (const key in _this.formValue) {
      if (!notvalueArr.includes(key)) {
        _this.formValue[key] = ''
      }
    }
    return _this
  },
  /**
   * 此方法是取交集的方法，类似零售的按钮配置
   * @method 根据据方法(getObject)的返回,初始化formConfig配置,包括formData
   * @data 待解析的数据
   * @form this.formConfig
   */
  initFormConfig(data, form) {
    // form.formData = [];
    // form.formValue = {};
    // form.ruleValidate = {};
    const fD = form.formData || []
    const fV = form.formValue || {}
    const fR = form.ruleValidate || {}
    data.forEach((item) => {
      fD.forEach((fDitem) => {
        if (fDitem.colname == item.colname) {
          /*  ˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚ 生成formData结构 ˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚  */
          fDitem.style =
            fDitem.style == 'dynamic' ? null : fDitem.style ? fDitem.style : ''
          if (item.webconf && item.webconf.style) {
            // 元数据中的前端自定义参数（因为元数据无法直接配置style为time）
            fDitem.style =
              fDitem.style == 'dynamic'
                ? null
                : fDitem.style
                  ? fDitem.style
                  : 'time'
          }
          fDitem.label = item.name || ''
          fDitem.value = item.colname.toString()
          fDitem.width = fDitem.width || '6'
          fDitem.regx = fDitem.regx || ''
          fDitem.placeholder = fDitem.placeholder || ''
          fDitem.disabled = item.readonly || false
          if (fDitem.style == 'input') {
            // 普通input类型--方法绑定
            // fDitem.inputChange = item.inputChange; // 不能在此赋值，不会实时调用，导致值的动态监听无效
          } else if (item.display == 'select' || item.display == 'check') {
            // select/check类型--方法绑定、options赋值
            // fDitem.selectChange = item.selectChange; // 不能在此赋值，不会实时调用，以至于下拉类型的值的动态监听无效
            fDitem.options = item.combobox.map((i) => ({
              label: i.limitdesc,
              value: i.limitval,
            }))
          } else if (item.fkdisplay && fDitem.itemdata) {
            // 复杂类型--方法绑定、formDataItem的itemdata子对象赋值
            // fDitem.itemdata = item;
            fDitem.serviceId = fDitem.serviceId || 'r3-cp' // 不配置则框架根据路由上的表名默认拼接该中心的网关
            // fDitem.version = fDitem.version || '1.4' // // 必须
            fDitem.itemdata.display = item.colid || 'No-colid' // 必须，用于查询表数据
            fDitem.itemdata.display = item.colname || 'No-colname' // 必须
            fDitem.itemdata.display = item.display || 'No-text' // 非必须，展示什么类型(eg.text、xml等)，非特殊类型不用写
            fDitem.itemdata.fkdisplay = item.fkdisplay || 'No-fkdisplay' // 必须，复杂类型是什么类型(eg.drp、mrp等)
            fDitem.itemdata.isfk = item.isfk // 必须
            fDitem.itemdata.isnotnull = item.isnotnull // 必须
            fDitem.itemdata.name = item.name || 'No-name' // 必须
            fDitem.itemdata.readonly = item.readonly // 必须
            fDitem.itemdata.reftable = item.reftable || 'No-reftable' // 非必须，mrp类型时必须设置(/p/cs/getTableQuery)
            fDitem.itemdata.reftableid = item.reftableid || 'No-reftableid' // 同reftable
            fDitem.itemdata.valuedata = item.valuedata || '' // 必须，展示的值
            fDitem.itemdata.pid = item.refobjid || item.pid || '' // 必须，展示的值对应的那行数据的ID
            fDitem.oneObj = fDitem.oneObj
          }
          /*  ˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚ 生成formValue 并 赋值（新增时接口不会返回valuedata字段）˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚  */
          if (item.fkdisplay) {
            // 复杂类型的formValue赋值
            if (!item.valuedata) return
            fV[item.colname] = {
              pid: item.refobjid || '',
              valuedata: item.valuedata || '',
            }
            fV[`${item.colname}_pid`] = item.refobjid || ''
            fV[`${item.colname}_valuedata`] = item.valuedata || ''
            fV[`${item.colname.replace('_ID', '_ENAME')}`] =
              item.valuedata || ''
          } else if (item.display == 'select' || item.display == 'check') {
            // 下拉类型的接口会返回一个默认选中的值（元数据中字段的缺省值）
            fV[item.colname] = item.valuedata || item.defval || ''
          } else {
            fV[item.colname] = item.valuedata || item.defval || ''
          }
          /*  ˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚ 生成必填ruleValidate（针对input、select等普通类型 ˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚˚  */
          if (item.isnotnull) {
            fR[item.colname] = [
              {
                required: true,
                message: ' ',
              },
            ]
          }
        }
      })
    })
    form.formData = fD
    form.formValue = fV
    form.ruleValidate = fR
    return form
  },
  /**
   * 根据元数据配置接口(/p/cs/getTableQuery) - 返回 businessForm 数据格式
   * @param data
   * @returns {{formData: [], formValue: {}}}
   */
  initTableQuery(data) {
    let formData = [];
    let formValue = {};
    data.forEach((item) => {
      const comObj = {
        label: item.coldesc,
        value: item.colname,
        width: 6
      };
      switch (item.display) {
        case 'OBJ_FK': // popInput 下拉多选、下拉单选
          formValue[item.colname] = item.fkobj.searchmodel === 'drp' ? '' : [];
          formData.push({
            style: 'dropSelect',
            ...comObj,
            itemdata: {
              col: 1,
              autoRequest: item.autoRequest || {}, // 模糊传参
              tableRequest: item.tableRequest || {}, // 表格模糊传参
              colid: item.colid, // 当前字段的ID
              colname: item.colname, // 当前字段的名称
              datelimit: 'all',
              display: 'text',
              fkdisplay: item.fkobj.searchmodel || 'drp', // 外键关联类型
              fkdesc: item.coldesc,
              inputname: item.inputname, // 这个是做中文类型的模糊查询字段，例如ENAME
              isfk: true, // 是否有fk键
              isnotnull: false, // 是否必填
              isuppercase: false, // 是否转大写
              length: 9999999, // 最大长度是多少
              name: item.coldesc,
              readonly: false, // 是否可编辑，对应input   readonly属性
              reftable: item.fkobj.reftable, // 对应的表
              reftableid: item.fkobj.reftableid, // 对应的表ID
              row: 1,
              statsize: -1,
              type: item.type,//item.type, // 这个是后台用的
              valuedata: '', // 这个是选择的值
              pid: '',
            },
            oneObj: (e) => {
              formValue[item.colname] = e.pid? e.pid.split(','):[];
            },
          });
          break;
        case 'OBJ_SELECT': // 下拉框组件
          formValue[item.colname] = [];
          const options = [];
          item.combobox.forEach((item2) => {
            options.push({
              label: item2.limitdesc,
              value: item2.limitval
            });
          });
          formData.push({
            style: 'select',
            multiple: true,
            ...comObj,
            options
          });
          break;
        case 'OBJ_DATE': // 日期组件
          formValue[item.colname] = [];
          formData.push({
            style: 'date',
            ...comObj,
            type: 'datetimerange', // 日期组件类型,默认为data  (daterange)为双日期区间选择
            format: 'yyyy-MM-dd HH:mm:ss'
          });
          break;
        default:
          formValue[item.colname] = '';
          formData.push({
            style: 'input',
            ...comObj
          });
          break;
      }

    });
    return {
      formData,
      formValue
    };
  },
  /**
   * @method 根据各界面'各自的查询接口'返回的主表data，初始化详情的form值
   * @data {data} 待处理的数据对象
   * @replaceString 要转换为'_ENAME'还是'_NAME'，要取接口返回的name字段赋值给valuedata
   */
  transformForm(
    data,
    form,
    inputArr = [],
    drpArr = [],
    replaceString = '_NAME'
  ) {
    const fD = form.formData
    const fV = form.formValue
    for (const keyRes in data) {
      // input型
      for (const keyFv in fV) {
        if (keyRes == keyFv && inputArr.includes(keyFv)) {
          fV[keyFv] = data[keyRes]
        }
      }
      // drp/mrp型
      fD.forEach((item) => {
        if (keyRes == item.colname && drpArr.includes(item.colname)) {
          item.itemdata.pid = data[item.colname]
          item.itemdata.valuedata =
            data[item.colname.replace('_ID', replaceString)]
        }
      })
    }
    form.formData = fD
    form.formValue = fV
    return form
  },
  /**
   * 填充子表数据(p/cs/objectTableItem)
   * @param {*} table 子表表名
   * @param {*} objid 明细ID
   * @param {*} refcolid 子表id
   * @param {*} searchdata searchdata查询条件，可不传
   * @returns 表数据数组data
   */
  async initSubtable(table, objid, refcolid, searchdata = {}) {
    if (objid === -1) return
    const searchdatas = {
      column_include_uicontroller:
        searchdata.column_include_uicontroller || true,
      startindex: searchdata.startindex || 0,
      range: searchdata.range || 10,
      fixedcolumns: searchdata.fixedcolumns || {},
    }
    const formdata = new FormData()
    formdata.append('objid', objid)
    formdata.append('table', table)
    formdata.append('searchdata', JSON.stringify(searchdatas))
    formdata.append('refcolid', refcolid)
    formdata.append('omsT', +new Date())
    const res = await vm.service.common.objectTableItem(formdata)
    if (res.data.code === 0) {
      let rowData = [];
      let columns = [];
      res.data.data.row.map((row) => {
        const obj = {}
        for (const i in row) {
          obj[i] = row[i].val
        }
        rowData.push(obj)
      })
      res.data.data.tabth.map((it) => {
        let column = {}
        for (const i in it) {
          column[i] = it[i];
          column.key = it.colname;
          column.title = it.name;
        }
        columns.push(column)
      })
      const data = {
        otherData: res.data.data,
        rowData,
        columns,
      }
      return data
    } else {
      // 数据加载失败
      console.log('no objectItem data!')
      return []
    }
  },
  /**
   * 保存前校验必填不能为空
   * @valueArr 要校验的--普通input、select等类型的formValue值
   * @drpArr 要校验的--下拉等复杂类型的valuedata值
   * @return 该填的都填了就返回1，反之返回提示信息
   */
  validatorNotEmpty(formConfig, valueArr, drpArr, callback) {
    // 最好是初始化、赋值、修改……的时候，把所有的值都赋一个给对应的formValue，编辑formValue
    // 好像还是要分别写，便于提示……不能为空，遍历formData !不行，formData Item的value并没有改变，还是要遍历formValue
    // 只能双遍历了
    const fD = formConfig.formData
    const fV = formConfig.formValue
    let messages = ''
    // 类型一：
    valueArr.forEach((item) => {
      for (const key2 in fV) {
        if (key2 == item) {
          if (!fV[key2]) {
            fD.forEach((it) => {
              if (it.colname == key2) {
                messages += `${it.label}，`
              }
            })
          }
        }
      }
    })
    // 类型二：
    if (drpArr) {
      drpArr.forEach((item) => {
        fD.forEach((it) => {
          if (it.colname == item) {
            if (!it.itemdata.valuedata) {
              messages += `${it.itemdata.name}，`
            }
          }
        })
      })
    }
    messages = messages.replace(/，$/, ' ')
    const msg = `${messages}不能为空!`
    if (typeof callback == 'function') callback(!messages ? '' : msg);
    if (!messages) {
      return ''
    } else {
      return msg
    }
  },
  /**
   * 置为不可编辑
   * @valueArr 要置为不可编辑的--input、select等普通类型formItem
   * @drpArr 要置为不可编辑的--下拉等复杂类型formItem
   * @return
   */
  formItemDisable(formData, valueArr = [], drpArr = []) {
    const fD = formData
    fD.forEach((it) => {
      it.display = valueArr.includes(it.colname)
      it.itemdata.readonly = drpArr.includes(it.colname)
    })
    return fD
  },

  /* ============================================== 【Form】表单 END ============================================== */

  //拼接网关前缀;
  splicingGateWay(gateWay, url) {
    let prefix = ''
    if (gateWayFlag) {
      for (let [k, v] of Object.entries(this.gateWayPrefix)) {
        console.log(k, v)
        if (gateWay == k) {
          prefix = v
        }
      }
    }

    let resUrl = prefix.concat(url) //网关打开自动
    return resUrl
  },

  // 数组对象去重
  unrepeated(targetArr, id) {
    let obj = {}
    let okArr = targetArr.reduce((cur, next) => {
      obj[next[id]] ? '' : (obj[next[id]] = true && cur.push(next))
      return cur
    }, []) //设置cur默认为空的数组
    return okArr
  },

  /**
   * 标准接口(eg./cs/QueryList,/cs/getTableQuery等)动态拼接网关
   * @param {*} src
   * @returns
   */
  splitServiceID(src) {
    let reSrc = src
    const serviceIDMap = JSON.parse(localStorage.getItem('serviceIdMap'))
    const path = R3.router.history.current.fullPath
    const sysMark = path.split('/')[1]
    const routeKey = path.split('/')[2]
    const serviceIdConfig = ['r3-cp']
    // 标准/定制(eg.零售发货单列表) - 且 菜单中存在(localStorage中存在)
    if (serviceIDMap.hasOwnProperty(routeKey)) {
      return reSrc
    } else {
      // 定制 且 菜单中不存在(eg.零售发货单详情、定制的新增/详情)
      reSrc = `/${serviceIdConfig[0]}${reSrc}`
      return reSrc
    }
  },
  /**
   * 定制按钮 -- 按钮是否需要disabled
   */
  buttonHasDisable(textArr, ButtonArr, disabled) {
    ButtonArr.forEach((item) => {
      if (textArr.includes(item.text)) {
        item.disabled = disabled
      }
    })
  },
  mainContentLoading(loading = false) {
    const doms = document.querySelector('.vue-loading');
    if (loading) {
      if (doms) return;

      // 1、创建构造器，定义loading模板
      const LoadingTip = Vue.extend({
        template: `
                    <div  class="vue-loading">
                      <div class="R3-Loading loader "></div>
                    </div>`,
      });

      // // 2、创建实例
      const tpl = new LoadingTip().$mount().$el;

      // 3、如何传入模块和当前页面模块相同，则把创建的实例添加到容器中
      const dom = document.querySelector(
        `#${window.vm.$router.currentRoute.params.tableName || window.vm.$router.currentRoute.params.customizedModuleName}`
      );

      if (!dom) return
      dom.appendChild(tpl);
    } else {
      doms.remove()
    }
  },

  /**
   * 公共接口获取表头
   * @param {*} length
   */
  getCommonColumn(self,tableName){
    return new Promise(async (resolve)=>{
      let data = await self.service.orderCenter.initObject({"TABLE":tableName});
      let obj = {}
      if (data.data.code !== -1) {
        let handleTh = data.data.data.DATA.map(element => ({title:`${element.headerName}`,key:`${element.field}`,dataAcessKey:`${element.field}`}));
        obj = {
          'sourceData':data.data,
          'handleTh':handleTh
        }
      }
      resolve(obj)
    })
  },
  /**
   * 公共接口获取数据
   * @param {*
   *  ID // 明细id
   *  TABLE // 主表名
   *  SUB_TABLE // 明细表名
   *  PT_SKU // true平台 false商品
   *  REFRESH //是否加密
   *  index  //当前页
   * }
   */
   getTableData(self,params){
    return new Promise(async (resolve)=>{
      const data = await self.service.orderCenter.queryObject(params);
      let obj = {}
      if (data.data.code !== -1) {
        obj = {
          'sourceData':data.data,
          'SUB_ITEM':data.data.data.DATA.SUB_ITEM
        }
      }
      resolve(obj)
    })
  },
  /**
   * ark table 添加合计行
   */
  totalColumn(totalKey,resData){
      // 生成map对象
      let mapObj = new Map();
      totalKey.forEach(e => { mapObj.set(e,0) });
      // 编辑查询
      resData.forEach(e => {
        totalKey.forEach(v => {
          if(e[v] !== undefined) mapObj.set(v,this.floatNumber($utils.accAdd(Number(mapObj.get(v)), Number(e[v]))))
        });
      });
      return Object.fromEntries([...mapObj])
  }
}


// 系统内提示类文案处理
const baseSet = {
  className: 'ark-dialog',
  title: '错误',
  mask: true,
}
const tipObj = {
  // 仅有'确认'按钮，没有'取消'按钮，有提示icon
  $fcError: (m) => {
    let obj = m
    if (typeof(obj) == 'string') {
      obj = {
        content: m
      }
    }
    Ark.Modal.fcError({ ...baseSet, ...obj})
  },
  $fcWarn: (m) => Ark.Modal.fcWarning({...baseSet, ...{ title: '警告' }, ...m}),
  $fcSuccess: (m) => Ark.Modal.fcSuccess({...baseSet, ...m}),
}
for (const key in tipObj) {
  window[key] = tipObj[key]
}

/* ============================================== 【FILE】END ============================================== */

// 给Number类型增加一个mul方法，调用起来更加方便。
Number.prototype.mul = function (arg) {
  return custUtils.accMul(arg, this);
};
// 给Number类型增加一个div方法，调用起来更加方便。
Number.prototype.div = function (arg) {
  return custUtils.accDiv(this, arg);
};

//
// Number.prototype.toFixed = function(fractionDigits) {
//   return ( parseInt((this * Math.pow( 10, fractionDigits ) + 0.5).toString())/ Math.pow( 10, fractionDigits )).toString();
// }

/**
 * 修改了原型上的toFixed方法
 * @param {*} length
 * @returns
 * 效果：1.6800000000000068.toFixed(2) = 1.69
 */
Number.prototype.toFixed = function (length) {
  let carry = 0; // 存放进位标志
  // let num; // num为原浮点数放大multiple倍后的数，multiple为10的length次方
  const str = `${this}`; // 将调用该方法的数字转为字符串
  let dot = str.indexOf('.'); // 找到小数点的位置
  if (dot != -1) {
    if (str.slice(dot + length + 1, dot + length + 2) >= 5) carry = 1; /* 找到要进行舍入的数的位置，手动判断是否大于等于5，满足条件进位标志置为1,这里原作者用的是str.substr(dot + length + 1, 1) */
  }
  // 需要舍入的数字如果小数位小于等于length，则不处理；
  if (this.toString().length - dot - 1 <= length) {
    return this;
  }
  const multiple = 10 ** length; // 设置浮点数要扩大的倍数
  const num = Math.floor(this * multiple) + carry; // 去掉舍入位后的所有数，然后加上我们的手动进位数
  let result = `${num / multiple}`; // 将进位后的整数再缩小为原浮点数
  /*
  * 处理进位后无小数
  */
  dot = result.indexOf('.');
  if (dot === -1) {
    result += '.';
    dot = result.indexOf('.');
  }
  /*
  * 处理多次进位
  */
  const len = result.length - (dot + 1);
  if (len < length) {
    for (let i = 0; i < length - len; i++) {
      result += 0;
    }
  }
  return result;
}


